module.exports = __webpack_public_path__ + "img/xn.1e87efe0.jpg";